<!-- ======= Breadcrumbs ======= -->
<!-- <section class="breadcrumbs">
    <div class="container">

        <div class="d-flex justify-content-between align-items-center">
            <h2>Club Leagues </h2>
           
              <p-breadcrumb [model]="items"></p-breadcrumb>
            ---- <ol>
                    <li [model]="items"><a href="index.html">Home</a></li>
                    <li>Products </li>
                </ol>
           
        </div>

    </div>
</section> -->
<!-- End Breadcrumbs -->
<!-- <div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="secure-shopping about-fasinating-diamond">
        <p-carousel [value]="bannerImageList" [numVisible]="1" [numScroll]="1" [circular]="true"
            [showIndicators]="false" [showNavigators]="false" [responsiveOptions]="carouselResponsiveOptions">
            <ng-template let-banner pTemplate="item">
                <div class="product-item">
                    <div class="product-item-content">
                        <div class="p-mb-1 banner-item-main">
                            <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="container-fluid p-0">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">
                   
                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div> -->

<section class="find-partner-page">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="right-side-section col-md-12">
            <div class="right-top-bar">
              <div class="col-md-12">
                <div class="section-title-text text-center pt-4">
                    <h1 class="title">CLUB LEAGUE</h1>
                </div>
              </div><br>
              <div class="prv-2">
                <h4>ABOUT THE LEAGUE</h4>
                <p>The Tennis Premier League, being the first of its kind, aims to cater to the growing popularity of
                  tennis and to give a platform to the nation’s young talent. It also equips them with the confidence to
                  battle global competition.</p>
                <P>The League has witnessed 3 very successful seasons in 2018 October, 2019 December and 2021 December.
                  All the top ranked players of India participated and the best coaches of the country mentored their
                  respective teams. Along with the support of famous celebrities this is undoubtedly one of the biggest
                  tennis event’s in India.</P>
                <P>The League is all set to flag off a bigger and better fourth season at the Balewadi Stadium in Pune
                  in December 2022.</P>
                <P>Each of the teams will have a top 10 ranked player of India in every category. The added attraction
                  will be the participation of the wheelchair players and the support of a well known celebrity.</P>
                <P>Each team will be assigned a mentor, a coach and a nutritionist to hone their skills in every aspect.
                </P>
                <P>Initiated by Skygoal Sports Pvt ltd in association with AITA and MSLTA along with the support of Mr
                  Leander Paes, TPL’s season 1 and 2 has already garnered the love of the nation. With season 3, it’s
                  all about global recall</P>
              </div>
              <div class="prv-2">
                <h4>OUR VISION</h4>
                <p>The vision of Skygoal Sports Pvt Ltd is to popularise tennis as a sport akin to cricket and football.
                  We intend to promote the young talented players of our country and support the top wheelchair players
                  of India by turning them into household names and national celebrities. Our motto is to make the
                  Tennis Premier League as big as the IPL, PBL & PRO KABBADI.</p>
              </div>
              <div class="prv-2">
                <h4>OUR BACKGROUND</h4>
                <p>The concept of Tennis Premier League was the brainchild of Mr Kunal Thakkur and Mr Mrunal Jain.</p>
                <p>This young dynamic duo are highly motivated to market the League with global level branding and make
                  it well structured and executed.</p>
                <p><b>Kunal Thakkur</b> is an ex National Level Tennis Player and is in the coaching business in Mumbai
                  for the last 18 years. He currently has his academies at Juhu Club Millennium, Jamnabai Narsee School,
                  Celebration Sports Club ( Lokhandwala) and Goregaon Sports Club. His Academy is currently training
                  over 1000 students all over Mumbai and is a favorite with many national level players and celebrities
                  including Mr. Leander Paes, Mr. Vishal Bhardwaj, Ms. Masaba Gupta, Mr. Shashank Khaitan, Mrs Sonali
                  Bendre, Mr. Himesh Reshammiya, Mrs. Rhea Pillai to name a few. The professional expertise of Mr. Kunal
                  Thakkur coupled with his passion for the sport has turned his dream of turning tennis into a very
                  popular sport and TPL as a widely acclaimed tournament.</p>
                <p><b>Mrunal Jain</b> is an actor cum entrepreneur known for his meaty roles played on leading
                  television networks across the nation. Mr. Jain made his debut with Ekta Kapoor’s show Mahabharat and
                  went on to play the lead role in many popular shows like Uttaran, Bandini & Nagarjuna. . His sharp
                  business acumen along with the glamour quotient he brings in have provided a complimentary
                  amalgamation which has made him one of the strong pillars of the company.</p>
                <p>Apart from the directors, the company deals with a team of highly experienced professionals and
                  consultants who represent our value in positively engaging our sponsors, teams, players, vendors and
                  associates. It is a highly enthusiastic team which keeps liaising with more and more professionals as
                  time progresses.</p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </section>
